import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { ic_arrow_back } from "react-icons-kit/md";
import MainWrapper from "../../MainWrapper";
import Title from "../../elements/Title";
import CustomButton from "../../elements/CustomButton";
import CncOrdersList from "./CncOrdersList";
import { CNC_ORDER_LIST_REQUEST } from "../../../_utils/constants/Customer";
import { STORE_INFO_REQUEST } from "../../../_utils/constants/admin/StoreInfo";

const FILTER_STORAGE_KEY = 'cnc-orders-filters';
const defaultListParamState = {
  quoteNumber: '',
  shipToPropertyName: '',
  unitName: '',
  salesPerson: '',
  StoreId: '',
  ScopeType: '',
  MeasureDate: '',
};

const getStoredFilters = () => {
  try {
    const saved = sessionStorage.getItem(FILTER_STORAGE_KEY);
    if (saved) return { ...defaultListParamState, ...JSON.parse(saved) };
  } catch (e) {}
  return defaultListParamState;
};

const CncOrders = ({
  auth: { auth, isAuthenticated },
  customerInfo: { cncOrderList, cncTotalCount, isLoading },
  StoreInfo: { storeInfo },
  fetchCncOrderList,
  fetchStoreInfo,
}) => {
  const navigate = useNavigate();
  const initialFilters = getStoredFilters();
  const hasActiveFilter = Object.keys(initialFilters).some(k => initialFilters[k] !== '');

  const [listParamState, setListParamState] = useState(initialFilters);
  const [paginate, setPaginate] = useState(hasActiveFilter ? 200 : 20);
  const [sort] = useState("desc");
  const [page] = useState(1);

  useEffect(() => {
    if (!isAuthenticated) navigate("/login");
  }, [auth, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchStoreInfo(auth[0].token, 1);
    }
  }, [auth, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      fetchCncOrderList(auth[0].token, sort, page, paginate, listParamState);
    }
  }, [auth, isAuthenticated, sort, page, paginate, listParamState]);

  useEffect(() => {
    try {
      sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(listParamState));
    } catch (e) {}
  }, [listParamState]);

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setPaginate(value.length > 0 ? 200 : 20);
    setListParamState(prev => ({
      ...prev,
      [id]: id === 'quoteNumber' ? value.trim() : value.trimStart(),
    }));
  };

  const handleResetFilters = () => {
    try { sessionStorage.removeItem(FILTER_STORAGE_KEY); } catch (e) {}
    setListParamState(defaultListParamState);
    setPaginate(20);
  };

  const hasSavedFilter = useMemo(
    () => Object.keys(listParamState).some(k => listParamState[k] !== ''),
    [listParamState]
  );

  const storeList = useMemo(() => {
    if (storeInfo) return storeInfo.map(v => ({ label: v.storeName, value: v.storeName }));
    return [];
  }, [storeInfo]);

  const handleQuoteClick = (row) => {
    localStorage.removeItem('Existing_Orders');
    navigate(`/cnc-estimate/contactInfoId=${row.ContactInfoId}/unitId=${row.unitId}/jobNum=${row.jobNo}`);
  };

  return (
    <MainWrapper>
      {isLoading && (
        <div className="loading-container"><div className="spinner-border"></div></div>
      )}
      <div className="container">
        <div className="sub-header mt-5 mb-3">
          <Title>CnC Measures</Title>
          <Link className="btn btn-primary me-1" to="/dashboard">
            <Icon icon={ic_arrow_back} />Back
          </Link>
          {hasSavedFilter && (
            <CustomButton variant="outline-secondary" className="me-1" handleClick={handleResetFilters}>
              Reset Search
            </CustomButton>
          )}
        </div>
        <CncOrdersList
          cncOrderListing={cncOrderList || []}
          totalCount={cncTotalCount}
          paginate={paginate}
          setPaginate={setPaginate}
          listParamState={listParamState}
          handleFilterChange={handleFilterChange}
          storeList={storeList}
          onQuoteClick={handleQuoteClick}
        />
      </div>
    </MainWrapper>
  );
};

const mapStateToProps = ({ auth, customerInfo, StoreInfo }) => ({
  auth,
  customerInfo,
  StoreInfo,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCncOrderList: (token, sort, page, paginate, listParamState) =>
    dispatch({ type: CNC_ORDER_LIST_REQUEST, token, sort, page, paginate, listParamState }),
  fetchStoreInfo: (token, storeType) => dispatch({ type: STORE_INFO_REQUEST, token, storeType }),
});

export default connect(mapStateToProps, mapDispatchToProps)(CncOrders);
